<div class="wa-table-details calendar__event__details" *ngIf="event">
  <div class="columns">
    <div>
      <div class="calendar__event__tags">
        <span class="tag" *ngIf="event.isWorldRecordEvent === true">
          {{'world_record' | transloco}} {{'Status' | transloco}}
        </span>
        <span class="tag" *ngIf="event.isWorldRanking === true">
          {{'world_ranking_status' | transloco}}
        </span>
        <span class="tag" *ngIf="event.isPWRE">{{'para_world_ranking_status' | transloco}}</span>
        <span
          class="tag tag--secondary"
          *ngIf="event.level && event.levelLabel !== 'World Cup'"
          >{{ event.levelLabel }}</span>
      </div>
      <div *ngIf="event.venue"><label>{{'Venue' | transloco}}:</label> {{ event.venue }}</div>
      <div class="calendar__event__details__place">
        <label>{{'Location' | transloco}}:</label> {{ event.place }}, {{ event.countryName }}
      </div>
      <br />
      <div *ngIf="event.sublevel">
        <label>{{'Type' | transloco}}:</label> {{ event.sublevel }}
      </div>
      <br />
      <div>
        <label>{{'Categories' | transloco}}:</label>
        <div *ngFor="let category of event.comdivisions">
          {{ filter_service.getNameOfCategories(category) }}
        </div>
      </div>
    </div>
    <div class="calendar__event__details__links">
      <a
        [href]="event.links['Web']"
        *ngIf="event.links && event.links['Web']"
        target="_blank"
        class="icon--web"
        >{{'Website' | transloco}}</a
      >
      <a
        [href]="'mailto:' + event.links['E-Mail']"
        *ngIf="event.links && event.links['E-Mail']"
        class="icon--email"
        >{{'Email' | transloco}}</a
      >
      <a
        [href]="event.links['Facebook Official Page']"
        *ngIf="event.links && event.links['Facebook Official Page']"
        target="_blank"
        class="icon--facebook"
        >{{'Facebook' | transloco}}</a
      >
      <a
        [href]="event.links['Twitter Account']"
        *ngIf="event.links && event.links['Twitter Account']"
        target="_blank"
        class="icon--twitter"
        >{{'Twitter' | transloco}}</a
      >
    </div>
    <div class="calendar__event__details__links">
      <a
        [href]="event.links['Registration URL']"
        *ngIf="event.links && event.links['Registration URL']"
        class="icon--registration"
        >{{'Registration' | transloco}}</a
      >
      <a
        [href]="event.youtubelive"
        *ngIf="event.youtubelive !== ''"
        class="icon--live"
        >{{ event.youtubelive ? event.youtubelive : "" }} Live</a
      >
      <a [href]="event.webUrl" *ngIf="event.withRes" class="icon--medal"
        >{{'Results' | transloco}}</a
      >
    </div>
  </div>
  <div class="calendar__event__documents">
    <ng-container *ngIf="docsStore.loadingRef === false; else loading">
      <div>
        <div class="separator" *ngIf="docsStore.data.length > 0">
          <label>{{'Documentation' | transloco}}</label>
        </div>
        <div class="doc container" *ngFor="let doc of docsStore.data">
          <span
            [ngSwitch]="
              (doc.MimeType?.split('/'))[1] ? (doc.MimeType?.split('/'))[1].trim() : ''
            "
          >
            <img
              *ngSwitchCase="'pdf'"
              class="icon"
              [lazyLoad]="'../../../../../modules/custom/wa_angular/app/assets/icons/pdf-icon.png'"
            />
            <img
              *ngSwitchCase="
                'vnd.openxmlformats-officedocument.wordprocessingml.document'
              "
              class="icon"
              [lazyLoad]="'../../../../../modules/custom/wa_angular/app/assets/icons/docx-icon.png'"
            />
            <img
              *ngSwitchCase="'msword'"
              class="icon"
              [lazyLoad]="'../../../../../modules/custom/wa_angular/app/assets/icons/docx-icon.png'"
            />
          </span>
          <a
            target="_blank"
            class="doc"
            [href]="doc.URL"
            download="{{ doc.Name }}.{{
              (doc.MimeType?.split('/'))[1] ? (doc.MimeType?.split('/'))[1] : ''
            }}"
            >{{ doc.Name }}</a
          >
        </div>
      </div>
    </ng-container>
    <ng-template #loading>
      <div class="loading-throbber"></div>
    </ng-template>
  </div>
</div>
